// SRTP / DTLS-SRTP helpers for WebRTC SDP munging
// V14 Bug 8: ensure all media lines use the encrypted RTP/SAVPF profile so
// Telnyx "SRTP Optional" mode works securely. Modern browsers use DTLS-SRTP
// by default — these helpers verify that and log if anything tries to fall
// back to plain RTP/AVP.

/**
 * Returns true if the SDP uses an encrypted (SAVPF or SAVP) profile on every
 * audio/video m= line.
 */
export function isSdpEncrypted(sdp) {
  if (!sdp) return false;
  const mLines = sdp.split('\n').filter((l) => l.startsWith('m='));
  if (mLines.length === 0) return false;
  return mLines.every((m) => /RTP\/SAVPF?/.test(m));
}

/**
 * Force every m= line in the SDP to use the secure RTP/SAVPF profile.
 * No-op if already secure.
 */
export function enforceSecureRtpProfile(sdp) {
  if (!sdp) return sdp;
  if (isSdpEncrypted(sdp)) return sdp;
  console.warn('[SRTP] SDP contained insecure RTP/AVP profile — forcing to RTP/SAVPF');
  return sdp.replace(/^m=([a-z]+) (\d+) RTP\/AVPF? /gim, 'm=$1 $2 RTP/SAVPF ');
}

/**
 * Verify the SDP advertises DTLS-SRTP via fingerprint attribute.
 * (Modern browsers always include this when creating offer/answer with default config.)
 */
export function hasDtlsFingerprint(sdp) {
  if (!sdp) return false;
  return /a=fingerprint:[a-z0-9-]+ [0-9A-F:]+/i.test(sdp);
}
